"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M22.765 16.75a2.239 2.239 0 0 0 1.235-2c0-.601-.238-1.161-.651-1.574a2.483 2.483 0 0 0 .64-1.909C23.872 9.996 22.727 9 21.381 9h-6.177c.306-.929.796-2.632.796-4 0-2.169-1.843-4-3-4-1.015 0-1.747.559-1.81.607l-.003.002A.502.502 0 0 0 11 2v3.391L8.12 11.63l-.12.061v10.718c.814.384 1.844.591 2.5.591h9.179c1.089 0 2.042-.734 2.266-1.747a2.25 2.25 0 0 0-.181-1.502 2.24 2.24 0 0 0 1.001-3.001ZM5.5 24c.563 0 1.081-.19 1.5-.506V11H2.5A2.503 2.503 0 0 0 0 13.5v8C0 22.878 1.122 24 2.5 24h3Z"
  })]
});